import {createStatic} from 'styled-components-breakpoint'

const media = createStatic({ 
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
})

export default media



// WEBPACK FOOTER //
// ./src/utils/media.js